import { setupFormState } from '@/components/form/tidal-form'

import { PersonalizationFormValues } from './typings'

export const form = setupFormState<PersonalizationFormValues>({
  id: 'personalizationForm',
  initialValues: {
    id: '',
    weekStartsOn: 'su',
  },
})
